export const types = {
    COMPUTE_STAGES: 'COMPUTE_STAGES',
    GET_CONFIGS: 'GET_CONFIGS',
    START_POINT: 'START_POINT',
    FIND_AND_SAVE: 'FIND_AND_SAVE',
    FORM_AUTO_FILL: 'FORM_AUTO_FILL',
    FORM_DEFAULT_VALUES: 'FORM_DEFAULT_VALUES',
}